import {BaseComponent} from '../../../abstract/base.component';
import {Directive} from '@angular/core';

@Directive()

export abstract class SendAchMailAction extends BaseComponent {
  protected _sendAchMailUrl: string;
  protected abstract passSendAchMailResponse(res);
  protected abstract passSendAchMailError(err);
  protected sendAchMail(postBody) {
    this.loadFlag = true;
    this.dataManager.postRequest(this._sendAchMailUrl, postBody, 0)
      .subscribe(
        (response) => {
          this.loadFlag = false;
          this.passSendAchMailResponse(response);
        },
        error => {
          this.loadFlag = false;
          this.networkErrorHandler(error);
          this.passSendAchMailError(error.error);
        }
      );
  }
}
